/**
 * Where the web portal's page menu lives. On a laptop or desktop it is a fixed sidebar beside
 * the page; on a phone or tablet it is a drawer behind the header's menu button. Next to a
 * 260px sidebar a portrait tablet (768px) leaves the header too little room for search, the
 * child switcher and its buttons, so they ran off the right edge. No React here, so the rule
 * is tested in Node.
 */

/** The narrowest window that still keeps the sidebar open beside the page. */
export const SIDEBAR_MIN_WIDTH = 1024;

/** The fixed sidebar's width (components/common/WebSidebar.tsx). */
export const SIDEBAR_WIDTH = 260;

/**
 * The narrowest header with room for the full search box beside the title, the child switcher
 * and the buttons; narrower, search is an icon that opens the search sheet (as on phones).
 */
export const SEARCH_BOX_MIN_HEADER_WIDTH = 900;

/** True when the page menu is a drawer (opened from the header) rather than a fixed sidebar. */
export function usesMenuDrawer(windowWidth: number): boolean {
  return windowWidth < SIDEBAR_MIN_WIDTH;
}

/** How wide the page header is: the whole window, less the sidebar where there is one. */
export function headerWidth(windowWidth: number): number {
  return usesMenuDrawer(windowWidth) ? windowWidth : windowWidth - SIDEBAR_WIDTH;
}

/** True when the header shows the full search box rather than the search icon. */
export function showsSearchBox(windowWidth: number): boolean {
  return headerWidth(windowWidth) >= SEARCH_BOX_MIN_HEADER_WIDTH;
}
